import React from "react";
import { ReactComponent as Iphone } from "../../../assets/images/iphone.svg";
import { ReactComponent as Ipad } from "../../../assets/images/ipad.svg";
import { ReactComponent as Macbook } from "../../../assets/images/macbook.svg";
import { ReactComponent as Watchs } from "../../../assets/images/Applewatch.svg";
import { ReactComponent as Gadget } from "../../../assets/images/gadget.svg";
import { ReactComponent as Check } from "../../../assets/images/Check.svg";

function pickIcon(id) {
  if (id.includes("iphone")) return Iphone;
  if (id.includes("ipad")) return Ipad;
  if (id.includes("macbook")) return Macbook;
  if (id.includes("watch")) return Watchs;
  return Gadget;
}

function cx(...xs) {
  return xs.filter(Boolean).join(" ");
}

/**
 * CategoryGrid (Multi Select)
 * props:
 * - items: [{id,title,subtitle}]
 * - value: string[] (selected ids)
 * - onChange: (next: string[]) => void
 * - onItemClick?: (name, item) => void
 */
export default function CategoryGrid({ items = [], value = [], onChange, onItemClick }) {
  const selectedSet = React.useMemo(() => new Set(value || []), [value]);

  const toggle = (item) => {
    console.log("item", item)
    const id = item
    const name = item || "";
    onChange?.(selectedSet.has(id) ? [] : [id]);
    onItemClick?.(name, item);
  };

  return (
    <>
      {/* ✅ MOBILE: horizontal scroll */}
      <div className="md:hidden -mx-4 px-4">
        <div className="flex gap-4 overflow-x-auto no-scrollbar pb-1 snap-x snap-mandatory">
          {items.map((it) => {
            const Icon = pickIcon(it.id);
            const active = selectedSet.has(it.id);

            return (
              <button
                key={it.id}
                type="button"
                onClick={() => toggle(it)}
                aria-pressed={active}
                className={cx(
                  "relative snap-start flex-shrink-0 w-auto h-[76px] rounded-2xl border-2 text-left px-4 py-3 transition",
                  active
                    ? "border-[#047DED] bg-[#EAF4FF]"
                    : "border-black/10 bg-white hover:border-[#047DED4D] hover:bg-[#047DED12]"
                )}
              >
                {/* check badge */}
                {/* <span
                  className={cx(
                    "absolute right-1 top-0 inline-flex items-center justify-center transition",
                    active ? "opacity-100" : "opacity-0"
                  )}
                >
                  <Check className="w-5 h-5 text-[#047DED]" />
                </span> */}

                {/* content row */}
                <div className="flex items-center gap-3 h-full">
                  {/* ✅ icon size 1/3 */}
                  <Icon className="w-8 h-8" />

                  <div className="min-w-0 h-full justify-center">
                    <div className="text-[14px] font-extrabold text-slate-900 leading-5 truncate pt-1">
                      {it.title}
                    </div>
                    <div className="pb-6 text-[12px] text-slate-500 line-clamp-2">
                      {it.subtitle}
                    </div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* ✅ DESKTOP/TABLET: grid (เหมือนเดิม) */}
      <div className="hidden md:grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
        {items.map((it) => {
          const Icon = pickIcon(it.id);
          const active = selectedSet.has(it.id);

          return (
            <button
              key={it.id}
              type="button"
              onClick={() => toggle(it.id)}
              aria-pressed={active}
              className={cx(
                "relative w-full h-[130px] rounded-2xl border-2 text-left px-5 transition",
                active
                  ? "border-[#047DED] bg-[#EAF4FF]"
                  : "border-black/10 bg-white hover:border-[#047DED4D] hover:border-[2px] hover:bg-[#047DED12]"
              )}
            >
              {/* check badge */}
              <span
                className={cx(
                  "absolute right-4 top-4 inline-flex items-center justify-center transition",
                  active ? "opacity-100" : "opacity-0"
                )}
              >
                <Check className="w-6 h-6 text-[#047DED]" />
              </span>

              {/* ✅ icon (1/3 of old w-11 h-11) */}
              <div className="pt-4 w-full flex justify-start">
                <Icon className="w-11 h-11 self-center" />
              </div>

              {/* text */}
              <div className="mt-3 text-left">
                <div className="text-[18px] font-extrabold text-slate-900 leading-6">
                  {it.title}
                </div>
                <div className="pb-6 text-[14px] text-slate-500">
                  {it.subtitle}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </>
  );
}
